import axiosInstance from '../superadminAxiosInstance';

class SmsMessagesService {
	public async getMonthlySales(year: string) {
		const response = await axiosInstance.post(
			'/superAdmin/statistics/monthlySales',
			{
				year: year,
			},
		);

		return response.data.data.monthlySales;
	}

	public async getMonthlyApprovedAccounts(year: string) {
		const response = await axiosInstance.post(
			'/superAdmin/statistics/monthlyApprovedAccounts',
			{
				year: year,
			},
		);

		return response.data.data.monthlyApprovedAccounts;
	}

	public async getMonthlyCreditsSpent(year: string) {
		const response = await axiosInstance.post(
			'/superAdmin/statistics/monthlyCreditsSpent',
			{
				year: year,
			},
		);

		return response.data.data.monthlyCreditsSpent;
	}

	public async getMonthlyMessagesSent(year: string) {
		const response = await axiosInstance.post(
			'/superAdmin/statistics/monthlyMessagesSent',
			{
				year: year,
			},
		);

		return response.data.data.monthlyMessagesSent;
	}
}

// This type of exporting is intended to make sure service acts as a singleton.
export default new SmsMessagesService();
